import styled from '@emotion/styled'
import { Command } from 'cmdk'

import { theme } from '../../../constants'

export const FilterInput = styled(Command.Input)({
  background: 'none',
  border: 'none',
  font: 'inherit',
  fontSize: 14,
  fontWeight: theme.font.weight.legacy[500],
  outline: 'none',
  padding: `${theme.padding.button.medium.y}px ${theme.padding.button.small.x}px`,
  width: '100%',
})
